"use client";
import React from "react";
import { filter, find, map, get } from "utils/lodash";
import Day from "./Day";
import dayjs from "utils/dayjs";
import helper from "utils/helper";
import { useBookingStore } from "stores";
// Tạo một danh sách là một mảng các ngày từ ngày hôm nay đến 15 ngày sau đó và 2 ngày trước ngày hôm nay. Tổng cộng sẽ có 17 ngày trong mảng này.
const days = Array.from({ length: 17 }, (_, index) => {
  const date = dayjs()
    .startOf("day")
    .add(index - 2, "day");
  return date;
});
export default function ListDays({
  onChange,
}: {
  onChange?: (date: any) => void;
}) {
  const { bookings, selectedDate, setSelectedDate } = useBookingStore();
  const handler = {
    onChangeDate: (date: dayjs.Dayjs) => {
      setSelectedDate(date);
      onChange?.(date);
    },
  };

  const listDays = helper.formatListDays(bookings || []);

  // Add click and drag scrolling support
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [scrollLeft, setScrollLeft] = React.useState(0);

  React.useEffect(() => {
    const element = scrollRef.current;
    if (!element) return;

    // Mouse wheel support
    const handleWheel = (e: WheelEvent) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        return; // Let native horizontal scroll work
      } else if (e.deltaY !== 0) {
        e.preventDefault();
        element.scrollLeft += e.deltaY;
      }
    };

    // Mouse down - start dragging
    const handleMouseDown = (e: MouseEvent) => {
      setIsDragging(true);
      setStartX(e.pageX - element.offsetLeft);
      setScrollLeft(element.scrollLeft);
      element.style.cursor = "grabbing";
      element.style.userSelect = "none";
    };

    // Mouse leave - stop dragging
    const handleMouseLeave = () => {
      if (isDragging) {
        setIsDragging(false);
        element.style.cursor = "grab";
      }
    };

    // Mouse up - stop dragging
    const handleMouseUp = () => {
      setIsDragging(false);
      element.style.cursor = "grab";
      element.style.userSelect = "";
    };

    // Mouse move - perform drag
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - element.offsetLeft;
      const walk = (x - startX) * 1.5; // Multiply by 1.5 for faster scrolling
      element.scrollLeft = scrollLeft - walk;
    };

    element.addEventListener("wheel", handleWheel, { passive: false });
    element.addEventListener("mousedown", handleMouseDown);
    element.addEventListener("mouseleave", handleMouseLeave);
    element.addEventListener("mouseup", handleMouseUp);
    element.addEventListener("mousemove", handleMouseMove);

    // Set initial cursor
    element.style.cursor = "grab";

    return () => {
      element.removeEventListener("wheel", handleWheel);
      element.removeEventListener("mousedown", handleMouseDown);
      element.removeEventListener("mouseleave", handleMouseLeave);
      element.removeEventListener("mouseup", handleMouseUp);
      element.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isDragging, startX, scrollLeft]);

  return (
    <div
      ref={scrollRef}
      className="w-full overflow-x-auto overflow-y-hidden px-4 pt-2 scroll-smooth scrollbar-hide"
      style={{
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <div className="flex gap-2 w-max pb-2">
        {map(days, (item, index) => {
          const isSelected =
            selectedDate && dayjs(selectedDate).isSame(item, "day");
          const objBookingsOnDay = find(listDays, (listDay) => {
            return dayjs(get(listDay, "bookingDate")).isSame(item, "day");
          });
          const bookings = get(objBookingsOnDay, "bookings", []);
          const numberBookingsOnDay = bookings.length || 0;
          const waitingBookings = filter(
            bookings,
            (booking: any) => booking.status === "waiting"
          );
          const allAccepted =
            bookings?.length > 0 &&
            bookings?.every((booking: any) => booking.status === "accepted");
          return (
            <Day
              key={index}
              data={{
                date: item,
                numberBookingsOnDay,
                numberWaitingBookings: waitingBookings.length,
              }}
              allAccepted={allAccepted}
              isSelected={isSelected}
              onClick={() => {
                // Prevent click if we were dragging
                if (isDragging) {
                  return;
                }
                handler.onChangeDate(item);
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
